<template>
  <div class="container">
    <div class="content">
      <div class="anchor2">
        <div @click="show=!show" class="clickArea">{{$t('m.OnThisPage')}}<i class="el-icon-arrow-down"></i> </div>
        <div v-if="show">
          <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">方案一</a></p>
          <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">方案二</a></p>
          <!-- <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3"></a></p>
          <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4"></a></p>
          <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5"></a></p>
          <p @click="activeted(6)" class="s1"><a :class="{active:flag==6}" href="#box6"></a></p> -->
          <!-- <div class="subAnchor">
            <p @click="activeted(21)" class="s2"><a :class="{active:flag==21}" href="#box21">test</a></p>
            <p @click="activeted(22)" class="s2"><a :class="{active:flag==22}" href="#box22">test</a></p>
            <p @click="activeted(23)" class="s2"><a :class="{active:flag==23}" href="#box23">test</a></p>
            <p @click="activeted(24)" class="s2"><a :class="{active:flag==24}" href="#box24">test</a></p>
            <p @click="activeted(25)" class="s2"><a :class="{active:flag==25}" href="#box25">test</a></p>
            <p @click="activeted(26)" class="s2"><a :class="{active:flag==26}" href="#box26">test</a></p>
            <p @click="activeted(27)" class="s2"><a :class="{active:flag==27}" href="#box27">test</a></p>
          </div> -->
        </div>
      </div>
      <div class="p1">分润方案</div>
      <div id="box1" class="p2">方案一</div>
      <div class="p3">
        <ol style="padding-left:50px;word-break:break-all">
          <li>查询每个区块所有验证人数据，累加总股份。</li>
          <li>根据区块产量计算社区的 2%。</li>
          <li>计算剩下的 98%里的 20%按实际验证人状态平均分配具体产量</li>
          <li>计算剩下的 98%里的 80%所有验证人按股份分配具体产量</li>
          <li>查询每个区块给验证人投票的委托人股份，计算每个委托人区块产量</li>
          <li>累加每个区块每个委托人和验证人区块产量</li>
          <li>对委托人和验证人产量结算</li>
          <li>风控提现</li>
        </ol>
      </div>
      <div id="box2" class="p2">方案二</div>
      <div class="p3">
        <ol style="padding-left:50px;word-break:break-all">
          <li>启动节点打印每个区块产量日志，包含社区 2%，验证人 98%的具体产量</li>
          <li>通过 flume 采集验证人区块链产量日志清洗数据输入数据库</li>
          <li>查询每个区块给验证人投票的委托人股份，计算每个委托人区块产量</li>
          <li>累加每个区块每个委托人和验证人区块产量</li>
          <li>对委托人和验证人产量结算</li>
          <li>风控提现</li>
        </ol>
      </div>
      
    </div>
    
    <div class="wrapper">
    <div class="anchor1">
      <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">方案一</a></p>
      <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">方案二</a></p>
      <!-- <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3"></a></p>
      <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4"></a></p>
      <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5"></a></p>
      <p @click="activeted(6)" class="s1"><a :class="{active:flag==6}" href="#box6"></a></p> -->
      <!-- <div class="subAnchor">
        <p @click="activeted(21)" class="s2"><a :class="{active:flag==21}" href="#box21">test</a></p>
        <p @click="activeted(22)" class="s2"><a :class="{active:flag==22}" href="#box22">test</a></p>
        <p @click="activeted(23)" class="s2"><a :class="{active:flag==23}" href="#box23">test</a></p>
        <p @click="activeted(24)" class="s2"><a :class="{active:flag==24}" href="#box24">test</a></p>
        <p @click="activeted(25)" class="s2"><a :class="{active:flag==25}" href="#box25">test</a></p>
        <p @click="activeted(26)" class="s2"><a :class="{active:flag==26}" href="#box26">test</a></p>
        <p @click="activeted(27)" class="s2"><a :class="{active:flag==27}" href="#box27">test</a></p>
      </div> -->
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'shareProfit',
  data() {
    return {
      flag: 1,
      show: false
    }
  },
  methods: {
    activeted(i) {
      console.log('i',i);
      this.flag = i
    }
  },
  mounted() {
    window.scroll(0, 0)
  }
}
</script>


<style lang="sass" scoped>
span
  padding: 2px 5px
  color: red
  border: 1px solid #ccc
  font-size: 12px
@media screen and (min-width:980px)
  .container
    display: flex
    .content
      width: 78%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
      .p3
        line-height: 25px
        padding-bottom: 15px
        word-break: break-all
    .anchor2
      display: none
    .wrapper
      width: 22%
    .anchor1
      position: sticky
      top: 0px
      right: 0px
      padding: 0 15px
      padding-right: 0
      // width: 18%
      color: #525860
      font-size: 14px
      border-left: 1px solid #DADDE1
      .active  
        color: #7549A9
      .subAnchor
        padding: 0 15px
      a
        color: #525860
      a:hover
        color: #7549A9
        font-size: 15px
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
@media screen and (max-width:980px)
  .container
    display: flex
    .content
      overflow: auto
      // width: 75%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
        padding-top: 60px
        margin-top: -60px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
        padding-top: 60px
        margin-top: -60px
      .p3
        line-height: 25px
        padding-bottom: 15px
        word-break: break-all
    .anchor1
      display: none
    .anchor2
      background: #F2F2F2
      border-radius: 5px
      color: #000
      padding: 10px 15px
      padding-right: 0
      // width: 25%
      font-size: 16px
      .clickArea
        padding-right: 15px
        color: #000
        display: flex
        justify-content: space-between
      .active  
        color: #7549A9
      .subAnchor
        padding-left: 15px
      a
        color: #525860
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
</style>